export const settings = [
  {
    label: "Background",
    type: "background-color",
    selector: "form",
    value: "#0c2450"
  },
  {
    group: "content",
    type: "color",
    selector: "content",
    value: "#ffffff"
  },
  {
    group: "content",
    type: "font-weight",
    selector: "content",
    value: 700
  },
  {
    group: "field",
    type: "color",
    selector: "field",
    value: "#444951"
  },
  {
    group: "field",
    type: "border-color",
    selector: "field",
    value: "#ffffff"
  },
  {
    group: "field",
    type: "border-radius",
    selector: "field",
    value: 4
  },
  {
    group: "field",
    type: "font-weight",
    selector: "field",
    value: 700
  },
  {
    group: "button",
    type: "color",
    selector: "button",
    value: "#ffffff"
  },
  {
    group: "button",
    type: "background-color",
    selector: "button",
    value: "#c9284d"
  },
  {
    group: "button",
    type: "border-radius",
    selector: "button",
    value: 4
  },
  {
    group: "button",
    type: "font-weight",
    selector: "button",
    value: 700
  }
]
